/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/* global log */

const VALUE_TYPES = {
  BOOLEAN: "BOOLEAN",
  STRING: "STRING",
  NUMBER: "NUMBER",
}
Object.freeze(VALUE_TYPES)

// Simple helper method that returns the correct default value of a given type
const defaultTypeValueFactory = function (overrides = {}) {
  return function (type) {
    switch (type) {
      case VALUE_TYPES.BOOLEAN:
        return overrides[VALUE_TYPES.BOOLEAN] ?? false
      case VALUE_TYPES.STRING:
        return overrides[VALUE_TYPES.STRING] ?? ""
      case VALUE_TYPES.NUMBER:
        return overrides[VALUE_TYPES.NUMBER] ?? 0
      default:
        return null
    }
  }
}

const castValueToType = function (value, type) {
  // First check if our typing is already correct
  if (typeof value === type.toLowerCase()) return value

  // If the cast blows up, simply set the default value and log exception
  let defaultValue = null

  try {
    switch (type) {
      case VALUE_TYPES.BOOLEAN:
        defaultValue = false
        return "true" === value.toLowerCase()
      case VALUE_TYPES.STRING:
        defaultValue = ""
        return "" + value
      case VALUE_TYPES.NUMBER:
        defaultValue = 0
        return Number.parseInt(value)
      default:
        return null
    }
  } catch (error) {
    log.error(`Could not cast ${value} to ${type}`, error)
  }

  return defaultValue
}

export { castValueToType, defaultTypeValueFactory, VALUE_TYPES }
